import { Pipe, PipeTransform, inject } from '@angular/core';
import { ENVIRONMENT_API_TOKEN } from '@campus/environment';

interface StreamableContent {
  id: number;
}

@Pipe({
  name: 'streamUrl',
  standalone: false,
})
export class StreamUrlPipe implements PipeTransform {
  private api = inject(ENVIRONMENT_API_TOKEN);

  transform(eduContent: StreamableContent, isStream: boolean = true): string {
    if (!eduContent?.id) {
      console.log('StreamUrl pipe - No ID found, returning empty string');
      return '';
    }

    const redirect = [this.api.APIBase, 'api', 'EduContents', eduContent.id, 'redirectURL'];
    const params = isStream ? ['stream=true'] : [];
    const result = redirect.join('/') + (params.length > 0 ? '?' + params.join('&') : '');

    return result;
  }
}
